export default __webpack_public_path__ + "static/media/Star Track.efe7f0b6.svg";